"use client";

import { c as _c } from "react/compiler-runtime";
import React, { ComponentProps } from "react";
import { OrbitControls as DreiOrbitControls, OrbitControlsProps as DreiOrbitControlsProps } from "@react-three/drei";
export type CameraControlsRef = ComponentProps<typeof DreiOrbitControls>["ref"];
type CameraControlsProps = Pick<DreiOrbitControlsProps, "enabled" | "target"> & {
  ref: CameraControlsRef;
};
export const CameraControls: React.FC<CameraControlsProps> = t0 => {
  const $ = _c(4);
  const {
    enabled,
    target,
    ref
  } = t0;
  let t1;
  if ($[0] !== enabled || $[1] !== ref || $[2] !== target) {
    t1 = <DreiOrbitControls ref={ref} enabled={enabled} enableDamping={true} enablePan={false} target={target} minDistance={15} maxDistance={55} makeDefault={true} zoomSpeed={0.5} />;
    $[0] = enabled;
    $[1] = ref;
    $[2] = target;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
CameraControls.displayName = "CameraControls";
export default CameraControls;